declare global {
  interface Window {
    adobeDataLayer?: Array<Record<string, unknown>>;
    logAnalyticsEvents?: boolean;
  }
}

type HeadEvent = 'assetError' | 'pagePerformance';

export function track(
  event: HeadEvent,
  data: { content: Record<string, unknown> },
): void {
  if (typeof window === 'undefined') return;
  window.adobeDataLayer = window.adobeDataLayer || [];
  const entry = { event, data };
  try {
    if (window.logAnalyticsEvents) console.log('[Analytics]', entry);
    window.adobeDataLayer.push(entry);
  } catch (e) {
    // adobeDataLayer.push may have been overridden by Adobe Launch's ACDL extension.
    // A throw from a third-party push must not propagate and break global error capture.
    // eslint-disable-next-line no-console
    console.error('[analytics] track push failed', { event, error: e });
  }
}
